import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ScoreReportComponent } from './components/score-report/score-report.component';
import { PageFiltersComponent } from './components/page-filters/page-filters.component';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { MaterialModule } from '../material.module';
import { NoDataComponent } from './components/no-data/no-data.component';

@NgModule({
  declarations: [AlertDialogComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    ScoreReportComponent,
    PageFiltersComponent,
    MaterialModule,
    NoDataComponent,
    LoggerModule.forRoot({
      serverLoggingUrl: '/api/logs',
      level: NgxLoggerLevel.DEBUG,
      serverLogLevel: NgxLoggerLevel.ERROR,
    }),
  ],
})
export class SharedModule {}
